import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateSendBroadcast = {
  sendBroadcast: { data: null, loading: false, error: null },
};

export const sendBroadcast = createAsyncThunk('user/sendBroadcast', async ({ vacancyId, data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/${vacancyId}/broadcast`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSendBroadcast = {
  [sendBroadcast.pending]: (state) => {
    state.sendBroadcast.loading = true;
    state.sendBroadcast.error = null;
  },
  [sendBroadcast.fulfilled]: (state, action) => {
    state.sendBroadcast.loading = false;
    state.sendBroadcast.data = action.payload;
    state.sendBroadcast.error = null;
  },
  [sendBroadcast.rejected]: (state, action) => {
    state.sendBroadcast.loading = false;
    state.sendBroadcast.error = action.payload;
  },
};
